/* eslint-disable react/require-default-props */
import { IconButton } from '@material-ui/core';
import React from 'react';
// import { IoMdNotifications } from 'react-icons/io';
import { Headers } from './styles';

interface Props {
  label?: string
}

const Header: React.FC<Props> = ({ label }) => (
  <Headers>
    <span>{label}</span>
    <IconButton aria-label="delete" style={{ borderWidth: 1, borderColor: '#333333' }}>
      {/* <IoMdNotifications style={{ color: '#333333' }} /> */}
    </IconButton>
  </Headers>
);
export default Header;
